module.exports = __webpack_public_path__ + "img/pdf-logo.3d07c28c.png";